import { Injectable } from '@angular/core';
import { RestService } from './_rest.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService extends RestService{

  init(){
    this.endpoint = 'settings';
    this.modelname = 'setting';
    }
}
